import * as React from 'react';
import {
  BodySmall,
  SubTitleSmall,
} from '@spaced-out/ui-design-system/lib/components/Text';
import {TruncatedTextWithTooltip} from '@spaced-out/ui-design-system/lib/components/TruncatedTextWithTooltip';
import css from './module-addon-common.css';


export const LabelValue = ({
  label,
  value,
}: {
  label: string;
  value: string | React.ReactNode;
}) => (
  <div className={css.keyValue}>
    {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
    <BodySmall color="secondary">{label}:</BodySmall>
    {typeof value === 'string' ? (
      <SubTitleSmall>
        <TruncatedTextWithTooltip tooltip={{bodyMaxLines: 3}}>
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          {value}
        </TruncatedTextWithTooltip>
      </SubTitleSmall>
    ) : (
      value
    )}
  </div>
);
